import { ColumnsModel } from "@syncfusion/ej2-react-querybuilder";
import {
  equalOperator,
  greaterOperator,
  greaterOrEqualOperator,
  isNotNullOperator,
  isNullOperator,
  lessOperator,
  lessOrEqualOperator,
  notEqualOperator,
} from ".";

export class NumberColumn {
  constructor(private column: ColumnsModel) { }

  Operator = [
    equalOperator,
    notEqualOperator,
    greaterOperator,
    greaterOrEqualOperator,
    lessOperator,
    lessOrEqualOperator,
    isNullOperator,
    isNotNullOperator,
  ];

  ToColumn(): ColumnsModel {
    return {
      ...this.column,
      operators: this.Operator,
    };
  }
}
